import { Component, Input, OnInit } from '@angular/core';
import { MediaService } from 'src/app/services/media.service';

@Component({
  selector: 'app-discipline-card',
  templateUrl: './discipline-card.component.html',
  styleUrls: ['./discipline-card.component.sass']
})
export class DisciplineCardComponent implements OnInit {

  @Input() disc:any = {};

  constructor(private mediaService:MediaService) { }

  ngOnInit(): void {
    this.disc.pic = this.mediaService.getMediaItemUrl(this.disc.foto);
  }

}
